/**
 * The one way to turn a user-ish record into a display label: the display name
 * when the person has set one, otherwise their email address. Used wherever a
 * user is listed or attributed (chat owners, scope pickers, …) so every surface
 * falls back the same way. Accepts the snake_case shapes the API returns
 * (users.user_name / email_address) as well as already-projected owner_name /
 * owner_email pairs.
 */
export interface UserDisplayNameSource {
  user_name?: string | null;
  email_address?: string | null;
  owner_name?: string | null;
  owner_email?: string | null;
}

export const UNKNOWN_USER_LABEL = 'Unknown user';

export const getUserDisplayName = (
  user: UserDisplayNameSource | null | undefined,
  fallback: string = UNKNOWN_USER_LABEL
): string => {
  const name = (user?.user_name ?? user?.owner_name ?? '').trim();
  if (name) return name;
  const email = (user?.email_address ?? user?.owner_email ?? '').trim();
  return email || fallback;
};
